import React from 'react';
import WeddingCard from './components/WeddingCard.tsx';
import { CARD_2 } from './constants/cards.ts';
import './App.css';

// This codebase is configured to show only the Reception event.
// Sangeet Night data (CARD_2, SANGEET_COLORS, assets) are kept in the codebase
// for reference and can be activated when cloning this repo for a separate domain.

const App: React.FC = () => {
  return <WeddingCard cardConfig={CARD_2} />;
};

export default App; 